import axios, { AxiosRequestConfig } from 'axios'

import { IChangedMatched } from '@/types/matched'

export const createChangedMatched = async (
  matchedId: string,
  isToBeDeleted: boolean | null = null,
): Promise<IChangedMatched> => {
  const config: AxiosRequestConfig = {
    params: {},
  }
  try {
    const response = await axios.post<IChangedMatched>(
      'changed-matcheds',
      { matchedId, isToBeDeleted },
      config,
    )
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.changedMathceds.createChangedMatched')
  }
}
